import React from 'react';

const Loading = () => {
    return ( 
        <div className="loading-screen"></div>
     );
}
 
export default Loading;